import React, { useState, useEffect, FC, ChangeEvent } from "react";
import classes from "./Checkbox.module.css";

import Goldcheckbox from "../Goldcheckbox/Goldcheckbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

interface ICheckboxProps {
  master: number;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  name: string;
  offer: string;
}

const Checkbox: FC<ICheckboxProps> = ({ master, onChange, name, offer }) => {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked(false);
  }, [master]);

  const goldChangeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    if (!e.target) return;

    setChecked(e.target.checked);
    onChange(e);
  };

  return (
    <FormControlLabel
      control={
        <Goldcheckbox
          value={name}
          onChange={(e: any) => goldChangeHandler(e)}
          disabled={!offer[3]}
          checked={checked}
        />
      }
      label={
        <label>
          <div className={classes.Checkbox_block}>
            {offer[3] ? (
              <span className={classes.active}>
                <span className={classes.time}>{offer[1]} min </span>{" "}
                <span className={classes.Checkbox_offer}>{offer[0]} </span>
                <span className={classes.money}> {offer[2]} &#8364;</span>
              </span>
            ) : (
              <span className={classes.disabled}>
                <span className={classes.time}>{offer[1]} min </span>{" "}
                <span className={classes.Checkbox_offer}>{offer[0]} </span>
                <span className={classes.money}> {offer[2]} &#8364;</span>
              </span>
            )}
            <input
              className={classes.Checkbox}
              type="checkbox"
              value={name}
              name={name}
              onChange={(e) => goldChangeHandler(e)}
              disabled={!offer[3]}
            />
          </div>
        </label>
      }
    />
  );
};

export default Checkbox;
